import BuyWizard from "./components/wizard";
import style from "./styles.module.scss";

const Buy = () => {
  return (
    <section className={style.buyWizard}>
      <div className={style.buyWizard__container}>
        <BuyWizard />
      </div>
    </section>
  );
};

export default Buy;
